{
    "monster": {
        "key": "monster",
        "jobKey": "book/manmoth",
        "position": {
            "x": 9,
            "y": 4,
            "z": 1
        }
    },
    "54Ft8": {
        "position": {
            "x": 6,
            "y": 6,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "54Ft8"
    },
    "ashe": {
        "position": {
            "x": 4,
            "y": 6,
            "z": 1
        },
        "templateKey": "player/book/ashe",
        "key": "ashe"
    },
    "xtgor": {
        "position": {
            "x": 5,
            "y": 7,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "xtgor",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "TdaTp": {
        "position": {
            "x": 8,
            "y": 5,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "TdaTp",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "e1rOA": {
        "position": {
            "x": 2,
            "y": 4,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "e1rOA"
    },
    "lsv88": {
        "position": {
            "x": 3,
            "y": 5,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "lsv88"
    },
    "6tK4t": {
        "position": {
            "x": 9,
            "y": 4,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "6tK4t"
    },
    "HEBPk": {
        "position": {
            "x": 7,
            "y": 7,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "HEBPk",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "AAqn7": {
        "position": {
            "x": 9,
            "y": 6,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "AAqn7",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "fj7GP": {
        "position": {
            "x": 10,
            "y": 5,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "fj7GP",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "page": {
        "key": "page",
        "role": "page",
        "spriteSize": "contained", "imageKey": "book/page1",
        "type": "zone",
        "properties": [
            "no healthbar"
        ],

        "position": {
            "x": 2,
            "y": 5,
            "z": 1
        },
        "pageKeys": [
            "shadowbeast"
        ]
    }
}
